var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:'collection ' + _vm.type},_vm._l((_vm.collection),function(card){return _c('li',{key:card.id},[_c('Card',{attrs:{"card":card}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }